import { Injectable } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({
    providedIn: 'root',
})
export class ValidatorService {
    constructor() { }

    noWhitespaceValidator(control: AbstractControl) {
        let REGEXP = new RegExp(/^\s*\s*$/);
        return !control.value || REGEXP.test(control.value) ? { required: true } : null;
    }

    onlyAlphabetsNumbersAndSpacesNotAllowed(c: FormControl) {
        let REGEXP = /^(?![0-9\s]*$)[a-zA-Z0-9\s]+$/;
        return REGEXP.test(c.value) ? null : { nonAlphaNumericValidator: true };
    }
validateIFSC(c: FormControl){
    let REGEXP = /^[A-Z]{4}0[A-Z0-9]{6}$/;
    return REGEXP.test(c.value) ? null : { notValidIFSC: true };
}
    onlyAlphabetsAllowed(c: FormControl) {
        let REGEXP = /^[a-zA-Z]+$/;
        return REGEXP.test(c.value) ? null : { nonAlphaValidator: true };
    }
    nonNegativeValidator(c: FormControl): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            const value = control.value;
            if (value < 0) {
                return { nonNegativeValidator: true };
            }
            return null;
        };
    }

    emailValidator(c: FormControl) {
        //let REGEXP = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
        let REGEXP = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/;
        return REGEXP.test(c.value) ? null : { notValidEmail: true };
    }

    phoneNumberValidator(c: FormControl) {
        let REGEXP = /^\d{10}$/;
        return REGEXP.test(c.value) ? null : { notValidPhoneNumber: true };
    }

    // latitudeValidator(c: FormControl) {
        
    //     let REGEXP = /^(\+|-)?(?:90(?:(?:\.0{6,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{0,6})?))$/;
    //     return REGEXP.test(c.value) ? null : { latitudeValidator: true };
    // }
     latitudeValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value === null || value === undefined || value === '') return { required: true };

    const num = parseFloat(value);
    const regex = /^-?([0-8]?\d(\.\d{1,6})?|90(\.0{1,6})?)$/;

    if (!regex.test(value.toString()) || num < -90 || num > 90) {
      return { latitudeValidator: true };
    }

    return null;
  }

   longitudeValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value === null || value === undefined || value === '') return { required: true };

    const num = parseFloat(value);
    const regex = /^-?(1[0-7]\d(\.\d{1,6})?|[0-9]?\d(\.\d{1,6})?|180(\.0{1,6})?)$/;

    if (!regex.test(value.toString()) || num < -180 || num > 180) {
      return { longitudeValidator: true };
    }

    return null;
  }

    // longitudeValidator(c: FormControl) {
    //     let REGEXP = /^(\+|-)?(?:180(?:(?:\.0{6,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{0,6})?))$/;
    //     return REGEXP.test(c.value) ? null : { longitudeValidator: true };
    // }

    atLeastOneCheckboxCheckedValidator(formArr: AbstractControl): ValidationErrors | null {
        const filtered = (formArr as FormArray).value.filter((chk: any) => chk.selected);
        return filtered.length ? null : { hasError: true }
    }

    dateRangeValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
          const startDate = control.get('startDate')?.value;
          const endDate = control.get('endDate')?.value;
      
          if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
            return { dateRangeError: 'Start date cannot be greater than end date' };
          }
      
          return null;
        };
      }
    dateRangeValidators(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
           const start = control.get('startdate')?.value;
           const end = control.get('enddate')?.value;

        if (!start || !end) return null;

            const startDate = new Date(start);
            const endDate = new Date(end);

            if (endDate < startDate) {
            return { endBeforeStart: true };
            }

            if (endDate.getTime() === startDate.getTime()) {
          return { sameDate: true };
    }

    return null;
    }
        };

   timeFormatValidator(control: any) {
    // debugger
    if (!control.value) return null;

    // Accepts formats like 09:15 AM, 12:30 PM, 1:00 am, etc.
    const regex = /^(0?[1-9]|1[0-2]):[0-5][0-9]\s?(AM|PM|am|pm)$/;
    const isValid = regex.test(control.value);

    return isValid ? null : { invalidTimeFormat: true };
  }

  
    validateDateRange(startField: string, endField: string): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {

    const start = group.get(startField)?.value;
    const end = group.get(endField)?.value;

    if (!start || !end) {
      return null;
    }

     const startDate = new Date(start);
    const endDate = new Date(end);

    // Remove time part
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    const diffMs = endDate.getTime() - startDate.getTime();
    
    //const diffYears = diffMs / (1000 * 60 * 60 * 24 * 365);

    // Same date OR less than 1 year
    return diffMs > 0 ? null : { minYearGap: true };
    //return diffYears < 1 ? { minYearGap: true } : null;
  };
}
 capacityAreaValidator = ( minSqFtPerPerson : number ,maxSqFtPerPerson : number
): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const capacity = control.get('capPerSession')?.value;
    const area = control.get('areaInSqft')?.value;

    if (!capacity || !area) {
      return null; // wait until both values exist
    }

    const areaPerPerson = area / capacity;

    if (areaPerPerson < minSqFtPerPerson) {
          console.log(areaPerPerson)
               console.log(minSqFtPerPerson)
      return { insufficientArea: true };
  
    }

    if (areaPerPerson > maxSqFtPerPerson) {
      return { excessiveArea: true };
    }

    return null;
  };
};

currentMonthTargetLimitValidator(maxAllowed: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control || control.value == null) return null;

    const controlName = control.parent ? Object.keys(control.parent.controls)
      .find(name => control.parent?.get(name) === control) : null;

    if (!controlName) return null;

    const monthIndexMap: any = {
      Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
      Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11
    };

    const today = new Date();
    const currentMonth = today.getMonth();
    const currentDay = today.getDate();

    // Apply condition only if current month & half passed
    if (
      monthIndexMap[controlName] === currentMonth &&
      currentDay >= 1 &&
      control.value > maxAllowed
    ) {
      return { targetTooHigh: true };
    }

    return null;
  };
}

}